(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pz-main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = 'results-list[id^="PzMainCollection-"]';
    const SALE_CARD_SELECTOR = '.pzmc-product--sale';

    const findPriceTarget = (card) =>
      card.querySelector('product-price [ref="priceContainer"]') ||
      card.querySelector('product-price > div:first-child') ||
      card.querySelector('[data-price-container]');

    const syncSaleCard = (card) => {
      if (!(card instanceof Element)) return;

      const saleTemplate = card.querySelector('.pzmc__sale-price-template');
      if (!(saleTemplate instanceof HTMLTemplateElement)) return;

      const priceTarget = findPriceTarget(card);
      if (!(priceTarget instanceof Element)) return;

      /*
       * IMPORTANTE:
       * No guardamos la tarjeta como "sincronizada para siempre".
       *
       * En una carga en frío (por ejemplo, navegador privado), Horizon puede
       * hidratar <product-price> DESPUÉS de que este código haya ejecutado y
       * volver a escribir el precio nativo. Ese era el motivo por el que podía
       * verse bien con caché pero fallar en incógnito.
       *
       * Ahora comprobamos el contenido REAL del contenedor cada vez. Si Horizon
       * lo re-renderiza, este código vuelve a aplicar inmediatamente el precio
       * correcto sin duplicarlo.
       */
      const hasSalePrice = priceTarget.querySelector('.pzmc__sale-price');
      const hasComparePrice = priceTarget.querySelector('.pzmc__compare-price');

      if (hasSalePrice && hasComparePrice) {
        priceTarget.classList.add('pzmc__forced-price');
        priceTarget.setAttribute('data-pzmc-sale-price-synced', 'true');
        return;
      }

      priceTarget.replaceChildren(saleTemplate.content.cloneNode(true));
      priceTarget.classList.add('pzmc__forced-price');
      priceTarget.setAttribute('data-pzmc-sale-price-synced', 'true');
    };

    const syncSalePrices = (scope = document) => {
      if (!(scope instanceof Document || scope instanceof Element)) return;
      scope.querySelectorAll(SALE_CARD_SELECTOR).forEach(syncSaleCard);
    };

    const scheduleRetries = (scope) => {
      /*
       * Las cargas con caché y las cargas en frío no hidratan los Web Components
       * exactamente en el mismo momento. Estos reintentos son ligeros y hacen
       * que el resultado sea estable también en incógnito, móvil y conexiones
       * lentas.
       */
      [0, 60, 180, 450, 900, 1600].forEach((delay) => {
        window.setTimeout(() => syncSalePrices(scope), delay);
      });
    };

    const observeResultsList = (resultsList) => {
      if (!(resultsList instanceof Element)) return;

      if (resultsList.dataset.pzmcSaleObserver !== 'true') {
        resultsList.dataset.pzmcSaleObserver = 'true';

        let framePending = false;

        const observer = new MutationObserver(() => {
          if (framePending) return;
          framePending = true;

          window.requestAnimationFrame(() => {
            framePending = false;
            syncSalePrices(resultsList);
          });
        });

        observer.observe(resultsList, {
          childList: true,
          subtree: true
        });
      }

      syncSalePrices(resultsList);
      scheduleRetries(resultsList);
    };

    const scrollToHashProduct = () => {
      if (!window.location.hash) return;

      const id = window.location.hash.slice(1);
      if (!id) return;

      const card = document.getElementById(id);
      if (card) {
        card.scrollIntoView({ behavior: 'instant' });
      }
    };

    const init = () => {
      scrollToHashProduct();

      document.querySelectorAll(ROOT_SELECTOR).forEach(observeResultsList);
      syncSalePrices(document);
    };

    let initFramePending = false;

    const scheduleInit = () => {
      if (initFramePending) return;
      initFramePending = true;

      window.requestAnimationFrame(() => {
        initFramePending = false;
        init();
      });
    };

    const installRootObserver = () => {
      if (window.__pzmcRootObserverInstalled) return;
      window.__pzmcRootObserverInstalled = true;

      /*
       * Los filtros / infinite scroll de Horizon pueden sustituir nodos completos.
       * Este observer solo re-inicializa cuando aparece un nuevo results-list,
       * evitando depender del orden de carga de results-list.js.
       */
      const rootObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          for (const node of mutation.addedNodes) {
            if (!(node instanceof Element)) continue;

            if (
              node.matches?.(ROOT_SELECTOR) ||
              node.querySelector?.(ROOT_SELECTOR)
            ) {
              scheduleInit();
              return;
            }
          }
        }
      });

      rootObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    };

    const boot = () => {
      installRootObserver();
      init();

      /*
       * Un último barrido después de cargar todos los módulos del tema.
       * Es especialmente útil en primera visita / incógnito.
       */
      window.addEventListener('load', () => scheduleRetries(document), { once: true });
      window.addEventListener('pageshow', scheduleInit);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', scheduleInit);
    document.addEventListener('shopify:section:reorder', scheduleInit);
  })();

  } catch(e) { console.error(e); }
})();
})();
